import { render } from "./DueEventNotification.vue?vue&type=template&id=16a99c98&scoped=true"
import script from "./DueEventNotification.vue?vue&type=script&lang=js"
export * from "./DueEventNotification.vue?vue&type=script&lang=js"

import "./DueEventNotification.vue?vue&type=style&index=0&id=16a99c98&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a99c98"]])

export default __exports__